var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAalim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.556 30 0 2.5 15.278 15 25 0l9.722 15L50 2.5 44.444 30H5.556zm38.888 7.5c0 1.5-1.11 2.5-2.777 2.5H8.333c-1.666 0-2.777-1-2.777-2.5V35h38.888v2.5z",
    fill: "#075985"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAalim);
export default __webpack_public_path__ + "static/media/Aalim.70a80f4da2e839a3b387de87f57ef3d7.svg";
export { ForwardRef as ReactComponent };